import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "range",
})
export class RangePipe implements PipeTransform {
    public transform(value: number): number[] {
        if (!value || value <= 0) return [];

        return Array.from({ length: value }, (_, i) => i);
    }
}
